export default "__VITE_ASSET__449fa226__"